export const RESET = 'POST_LIST_RESET'
export const SET_ITEMS = 'POST_LIST_SET_ITEMS'
export const SET_ERROR = 'POST_LIST_SET_ERROR'
export const SET_VIEW = 'POST_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'POST_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/post/list/mutation_types.js